import { render, staticRenderFns } from "./TaskOwnerSelector.vue?vue&type=template&id=23d9aa1c&"
import script from "./TaskOwnerSelector.vue?vue&type=script&lang=ts&"
export * from "./TaskOwnerSelector.vue?vue&type=script&lang=ts&"
import style0 from "./TaskOwnerSelector.vue?vue&type=style&index=0&id=23d9aa1c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports